var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8971 9.55344H16.8495L13.7565 0L10.6452 9.55344L0.597656 9.53514L8.72357 15.4466L5.6123 25L13.7382 19.0886L21.8641 25L18.7712 15.4466L26.8971 9.55344Z",
    fill: "#CCFF8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4679 17.6049L18.7725 15.4453L13.7578 19.0873L19.4679 17.6049Z",
    fill: "#162D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ac37c3b71fc861eb5d147eda930d731e.svg";
export { ForwardRef as ReactComponent };